import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { ClientsResponse } from '../models/client.model';
import { removeEmptyParams } from '../helpers/removeEmptyParams';
import { Note } from '../interfaces/note';
import { jsonToFormData } from '../helpers/jsonToFormData';
import { tap } from 'rxjs';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  baseUrl = environment.apiUrl;
  http = inject(HttpClient);
  router = inject(Router);
  userService = inject(UserService);


  // User
  updateUserProfile(body: any) {
    const formData = jsonToFormData(body)
    return this.http.post<any>(`${this.baseUrl}profile`, formData).pipe(
      tap((res) => res.user ? this.userService.setUser(res.user) : null)
    );
  }

  // Clients
  getClients() {
    return this.http.get<ClientsResponse>(`${this.baseUrl}clients`);
  }
  getClientsById(id: number) {
    return this.http.get<any>(`${this.baseUrl}clients/${id}`);
  }
  getClientUsers(clientId: number) {
    return this.http.get<any>(`${this.baseUrl}clients/${clientId}/users`);
  }

  // Categories
  getCategories() {
    return this.http.get<any>(`${this.baseUrl}categories`);
  }

  // Quick Responses
  getQuickResponses() {
    return this.http.get<any>(`${this.baseUrl}quick-responses`);
  }

  // Create Ticket
  createTicket(body: any) {
    const formData = jsonToFormData(body);
    return this.http.post<any>(`${this.baseUrl}tickets`, formData);
  }

  // Announcements
  createAnnouncement(body: any) {
    const formData = jsonToFormData(body);
    return this.http.post<any>(`${this.baseUrl}announcements`, formData);
  }

  // Client Tickets
  getClientTickets(clientId: number) {
    return this.http.get<any>(`${this.baseUrl}clients/${clientId}/tickets`, { params: { per_page: 999 } });
  }
  searchTickets(params: { [key: string]: any }) {
    return this.http.get<any>(`${this.baseUrl}search`, { params });
  }
  getTickets(params: { [key: string]: any } = {}) {
    return this.http.get<any>(`${this.baseUrl}tickets`, { params: removeEmptyParams(params) });
  }
  getTicketById(id: number, params = {}) {
    return this.http.get<any>(`${this.baseUrl}tickets/${id}`, { params });
  }
  updateTicket(id: number, body: any) {
    return this.http.put<any>(`${this.baseUrl}tickets/${id}`, body);
  }
  closeTicket(id: number, params: any = {}) {
    return this.http.post<any>(`${this.baseUrl}tickets/${id}/close`, {}, {params});
  }
  reopenTicket(id: number, params: any = {}) {
    return this.http.post<any>(`${this.baseUrl}tickets/${id}/reopen`, {}, {params});
  }

  // Ticket Notes
  getTicketNotes(ticketId: number) {
    return this.http.get<Note[]>(`${this.baseUrl}tickets/${ticketId}/notes`);
  }
  sendTicketNote(ticketId: number, body: any) {
    return this.http.post<any>(`${this.baseUrl}tickets/${ticketId}/notes`, body);
  }
  deleteTicketNote(ticketId: number, noteId: number, params: any = {}) {
    return this.http.delete<any>(`${this.baseUrl}tickets/${ticketId}/notes/${noteId}`, {params});
  }
}
